import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const policies = [
  {
    number: "01",
    icon: "ri-flashlight-line",
    title: "成果に連動する事業モデル",
    description:
      "広告成果に応じた報酬体系を基本とし、成果条件を明確にしたうえで支援を行います。",
  },
  {
    number: "02",
    icon: "ri-link",
    title: "広告からLPまで一気通貫",
    description:
      "広告運用・クリエイティブ・LP・計測環境を分断せず、一貫した視点で改善を進めます。",
  },
  {
    number: "03",
    icon: "ri-bar-chart-2-line",
    title: "数値に基づく採算管理",
    description:
      "コンバージョンと採算の両面を数値で把握し、費用対効果の観点から改善を判断します。",
  },
  {
    number: "04",
    icon: "ri-shield-check-line",
    title: "法令・媒体基準の遵守",
    description:
      "広告表示に関する法令および各媒体のガイドラインを遵守し、適正な運用を行います。",
  },
];

const managementItems = [
  { icon: "ri-file-text-line", label: "契約管理" },
  { icon: "ri-settings-3-line", label: "運用管理" },
  { icon: "ri-lock-line", label: "情報管理" },
  { icon: "ri-calendar-check-line", label: "定期レポーティング・案件別採算確認" },
];

export default function Strengths() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section
      id="strengths"
      ref={ref}
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-accent/[0.02] to-transparent pointer-events-none" />

      <div className="relative max-w-6xl mx-auto">
        <div
          className={`section-animate ${isVisible ? "visible" : ""} text-center mb-16 md:mb-20`}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-muted mb-2">
            STRENGTH
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            事業運営の方針
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 lg:gap-12">
          {policies.map((policy, index) => (
            <div
              key={policy.number}
              className={`section-animate ${
                isVisible ? "visible" : ""
              } relative group`}
              style={{
                transitionDelay: isVisible
                  ? `${0.15 * (index + 1)}s`
                  : "0s",
              }}
            >
              <div className="flex items-start gap-5 md:gap-6">
                <div className="w-12 h-12 flex items-center justify-center border border-accent/30 shrink-0">
                  <i className={`${policy.icon} text-lg md:text-xl text-accent`} />
                </div>

                <div className="pt-1">
                  <h3 className="text-sm md:text-base lg:text-lg font-bold text-white mb-2 md:mb-3 tracking-tight">
                    {policy.title}
                  </h3>
                  <p className="text-xs md:text-sm text-text-secondary leading-relaxed">
                    {policy.description}
                  </p>
                </div>
              </div>

              <div className="mt-6 md:mt-8 ml-[4.25rem] md:ml-[4.5rem] h-px bg-border/60" />
            </div>
          ))}
        </div>

        <div
          className={`section-animate ${
            isVisible ? "visible" : ""
          } mt-16 md:mt-20 p-6 md:p-10 border border-border/60 bg-surface/40`}
        >
          <div className="flex items-center gap-3 mb-6 md:mb-8">
            <i className="ri-building-2-line text-accent text-lg md:text-xl" />
            <h3 className="text-sm md:text-base font-bold text-white tracking-tight">
              安定した取引に向けた管理
            </h3>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {managementItems.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-3 p-4 border border-border/50"
              >
                <div className="w-9 h-9 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-base text-accent`} />
                </div>
                <span className="text-xs md:text-sm text-text-secondary leading-snug">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}